import type { ActivityLogFilters } from '../services/operationsService';

// Query keys for the kernel feature's server reads. Keyed so a filter change
// (activity log) or a customer switch (customer lens) is a distinct cache entry,
// letting a reopened Kernel tab serve instantly from cache.
export const kernelKeys = {
  activityLog: (filters?: ActivityLogFilters) => ['kernel', 'activityLog', filters ?? {}] as const,
  deploymentMap: () => ['kernel', 'deploymentMap'] as const,
  driftDashboard: () => ['kernel', 'driftDashboard'] as const,
  controlPlaneHealth: () => ['kernel', 'controlPlaneHealth'] as const,
  customerControlPlane: (customerId: string | null) =>
    ['kernel', 'customerControlPlane', customerId] as const,
};
